/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { CanvasContent, IScreenPosition } from "src/modules/pe-landing-module/data/interfaces"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IPrimitiveProps } from "../section/Primitive"
import { default as CanvasCanvas } from "../useful/Canvas"

/* Protopia Ecosystem component */
export interface CanvasPrimitiveProps extends IPrimitiveProps {
   
}
const CanvasPrimitive = ( props: CanvasPrimitiveProps ): JSX.Element => { 
    const primitive: CanvasContent  = useComponentData<CanvasContent>(( props.primitive || {dimentions: {}} ) as CanvasContent )  
    const {position}                = usePosition( primitive )  
    useEffect(() => {
        addCSSClass(
            `landing-canvas-${primitive.id}`,
            ` .landing-canvas-${primitive.id} {
                width:${ getCssDemention(position.width, "200px") };
                height:${ getCssDemention(position.height, "200px") }; 
            }`
        )
        return () => removeCSSClass(`landing-canvas-${primitive.id}`)
    },[ primitive ])
    return <div className={ `landing-canvas-${primitive.id}` } data-primitive-type={primitive["data-primitive-type"]}>
        <CanvasCanvas data={{ ...primitive as any }} />
    </div>
}
export default CanvasPrimitive